export const currencies = [
    "MXN",
    "USD"
]